import { createFileRoute } from "@tanstack/react-router";

import { ShowViewer } from "../features/show/ShowViewer";

/** The icons. Two mounts: the window takes the pick, the stage says what there is to aim at. */
export const Route = createFileRoute("/show/viewer/$voteMount/$stageMount")({
  component: ViewerCanvas,
});

function ViewerCanvas() {
  const { voteMount, stageMount } = Route.useParams();
  return (
    <main>
      <ShowViewer voteMount={voteMount} stageMount={stageMount} />
    </main>
  );
}
